import { render, staticRenderFns } from "./Slack.vue?vue&type=template&id=fe15eeac"
import script from "./Slack.vue?vue&type=script&lang=js"
export * from "./Slack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe15eeac')) {
      api.createRecord('fe15eeac', component.options)
    } else {
      api.reload('fe15eeac', component.options)
    }
    module.hot.accept("./Slack.vue?vue&type=template&id=fe15eeac", function () {
      api.rerender('fe15eeac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/Slack.vue"
export default component.exports